import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';
import { PermissionArrayType } from '../../../types/other';

const customerCollaboratorRoles = getAllPermissionRolesForUserLevel('customer', ['owner', 'admin', 'user']);
const resellerEditorRoles = getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin', 'user']);
const telcloudEditorRoles = getAllPermissionRolesForUserLevel('telcloud', ['admin', 'user', 't3_admin', 'support']);
const telcloudAssignableRoles = [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud')];

export const ticketTelcloudAdminRoles = [
  PERMISSIONROLECONSTANTS.superadmin,
  ...getAllPermissionRolesForUserLevel('telcloud', ['admin']),
];

export const isCustomerTicketCollaborator = (role?: string | null): boolean =>
  !!role && customerCollaboratorRoles.includes(role);

export const canManageResponsibilityOnTicketForm = (id: number, role?: string | null): boolean =>
  id > 0 || (!!role && telcloudAssignableRoles.includes(role));

export const canCollaborateOnTicket = (role: string | null | undefined, canUpdate: boolean): boolean =>
  canUpdate || isCustomerTicketCollaborator(role);

export const ticketPermissions: PermissionArrayType = {
  CREATE: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...telcloudEditorRoles,
    ...resellerEditorRoles,
    ...customerCollaboratorRoles,
  ],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud'),
    ...getAllPermissionRolesForUserLevel('reseller'),
  ],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, ...telcloudEditorRoles, ...resellerEditorRoles],
  DELETE: [],
};
